export default __webpack_public_path__ + "static/media/Rectangle_blue_2.4829d627.png";